import campaignContactListTemplate from './campaignContactList.html';
import campaignContactListFilterModalTemplate from './campaignContactListFilterModal.html';

const contactFilterModal = {
    bindings: {
        campaignId: '<',
        refresh: '=',
        levelOfInterest: '=?',
    },

    template: campaignContactListTemplate,

    controller: function (
        $scope,
        $state,
        $ionicLoading,
        $ionicModal,
        $ionicPopup,
        ApiCampaigns,
        ApiInvestors,
        ApiSelections,
        ApiPicklist,
        MessageBox,
        filterHistory,
        $filter
    ) {
        this.contacts = [];

        this.showInvestorType = false;
        this.showLevelOfInterest = false;

        this.package = [];
        this.investorSubtypes = [];
        this.levelOfInterests = [];
        this.contactType = 'PACKAGE';
        this.modal = $ionicModal.fromTemplate(
            campaignContactListFilterModalTemplate,
            {
                scope: $scope,
            }
        );
        this.loading = [];
        this.MessageBox = MessageBox;
        this.filterHistory = filterHistory;
        this.sortOrder = {
            value: 'LEVEL_OF_INTEREST_DESC',
            direction: 'DESC',
            field: 'LEVEL_OF_INTEREST',
        };
        this.sortCriteria = [
            {
                value: 'LEVEL_OF_INTEREST_DESC',
                direction: 'DESC',
                field: 'LEVEL_OF_INTEREST',
            },
            {
                value: 'LEVEL_OF_INTEREST_ASC',
                direction: 'ASC',
                field: 'LEVEL_OF_INTEREST',
            },
            {
                value: 'ACCOUNT_NAME_ASC',
                direction: 'ASC',
                field: 'ACCOUNT_NAME',
            },
            {
                value: 'ACCOUNT_NAME_DESC',
                direction: 'DESC',
                field: 'ACCOUNT_NAME',
            },
            {
                value: 'AUM_DESC',
                direction: 'DESC',
                field: 'AUM',
            },
            {
                value: 'AUM_ASC',
                direction: 'ASC',
                field: 'AUM',
            },
            {
                value: 'LAST_NAME_ASC',
                direction: 'ASC',
                field: 'LAST_NAME',
            },
            {
                value: 'LAST_NAME_DESC',
                direction: 'DESC',
                field: 'LAST_NAME',
            },
            {
                value: 'TITLE_ASC',
                direction: 'ASC',
                field: 'TITLE',
            },
            {
                value: 'TITLE_DESC',
                direction: 'DESC',
                field: 'TITLE',
            },
        ];

        this.isFilterActive = false;
        this.filterParameter = { investorSubtypes: [], levelOfInterests: [] };

        this.filterParameterObj = {
            customerContactType: undefined,
            investorSubtypes: [],
            levelOfInterests: [],
            selectionId: undefined,
            searchText: undefined,
            firstQueryResult: undefined,
            sortOrder: 'LEVEL_OF_INTEREST',
            sortDirection: 'DESC',
        };

        this.toggleInvestorType = () => {
            this.showInvestorType = !this.showInvestorType;
        };

        this.toggleLevelOfInterest = () => {
            this.showLevelOfInterest = !this.showLevelOfInterest;
        };

        this.packageMoreData = false;
        this.packageloadingData = true;
        this.teamMoreData = false;
        this.teamloadingData = false;

        this.$onInit = () => {
            this.preLoadedFilter();

            // Investor Package (selections)
            ApiSelections.getSelectionsMinimal().then((packages) => {
                this.packageOne = packages || [];
            });

            // Investor Type
            ApiInvestors.getInvestorsSubtypes().then((subtypes) => {
                if (subtypes) {
                    this.investorSubtypes = subtypes.map((subtype) => {
                        return {
                            value: subtype,
                        };
                    });
                }
            });

            ApiPicklist.retrieveLevelsOfInterest().then((response) => {
                this.levelOfInterests = response.data.map((item) => {
                    return {
                        value: item.filterKey,
                        name: item.name,
                        color: item.color,
                        checked: false,
                        items: item.items
                            ? item.items.map((subitem) => {
                                  return {
                                      value: subitem.filterKey,
                                      name: subitem.name,
                                      checked: false,
                                      color: subitem.color,
                                  };
                              })
                            : null,
                    };
                });

                this.loadCombinedContacts();
            });
        };

        this.loadCombinedContacts = () => {
            this.packageloadingData = true;
            ApiCampaigns.getCampaignCombinedContacts(
                this.campaignId,
                this.filterParameterObj
            ).then((contacts) => {
                if (contacts) {
                    if (contacts.length < 50) {
                        this.packageMoreData = false;
                    } else {
                        this.packageMoreData = true;
                    }
                }
                this.packageContacts = contacts || [];
                this.contacts = this.contacts.concat(contacts || []);
                this.packageloadingData = false;
            });
        };

        this.loadMoreData = () => {
            if (this.packageMoreData) {
                this.getMoreCombinedContacts();
            }
        };

        this.getMoreCombinedContacts = () => {
            this.packageloadingData = false;
            this.filterParameterObj.firstQueryResult =
                this.packageContacts && this.packageContacts.length;

            ApiCampaigns.getCampaignCombinedContacts(
                this.campaignId,
                this.filterParameterObj
            ).then((contacts) => {
                if (!contacts) {
                    this.packageMoreData = false;
                } else {
                    this.packageMoreData = contacts.length < 50 ? false : true;
                    this.packageContacts =
                        this.packageContacts.concat(contacts);
                    this.contacts = this.contacts.concat(contacts);
                    $scope.$broadcast('scroll.infiniteScrollComplete');
                }
                this.packageloadingData = false;
            });
        };

        this.removeCampaignContact = (contact, index, type) => {
            this.showLoading();
            ApiCampaigns.deleteCampaignContact(this.campaignId, {
                contactIds: [contact.id],
            }).then((res) => {
                // Remove deleted campaign from campaign list view
                if (res) {
                    // show alert
                    $ionicPopup.alert({
                        title: '<b>Cannot delete</b>',
                        template:
                            '{{"CANNOT_REMOVE_CAMPAIGN_CONTACT_ALERT_MESSAGE" | translate}}',
                        okType: 'button-picton-blue',
                    });
                } else {
                    if ('PACKAGE' === type) {
                        this.contacts.splice(index, 1);
                        this.packageContacts.splice(index, 1);
                    } else if ('TEAM' === type) {
                        this.teamContacts.splice(index, 1);
                    }
                }
                this.hideLoading();
            });
        };

        this.promptRemoveCampaignContact = (contact, index, type) => {
            let dialogResult = $ionicPopup.confirm({
                title: $filter('translate')('DELETE_CAMPAIGN'),
                template: $filter('translate')('REMOVE_CAMPAIGN_CONTACT'),
            });

            dialogResult.then((res) => {
                if (res) {
                    this.removeCampaignContact(contact, index, type);
                }
            });
        };

        this.assignContactsToCampaign = () => {
            $state.go(
                'contacts',
                {
                    campaignId: this.campaignId,
                    callingPage: 'campaignDetail',
                },
                {
                    reload: true,
                }
            );
        };

        this.refresh = () => {
            this.loadCombinedContacts();
        };

        this.showLoading = () => {
            this.loading.push(1);
            $ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>',
            });
        };

        this.hideLoading = () => {
            this.loading.pop();
            if (this.loading.length === 0) $ionicLoading.hide();
        };

        this.retrieveContactDetailUisref = (customer) => {
            if (customer === null) {
                return 'contactsDetail({contactId: contact.contactInfo.contact.id, isCustomerContact: false})';
            } else {
                return 'customerContactsDetail({contactId: contact.contactInfo.contact.id, isCustomerContact: true})';
            }
        };

        // Show filter modal box
        this.openModal = () => {
            this.investorSubtypes.forEach((subtype) => {
                if (
                    this.filterParameterObj.investorSubtypes.includes(
                        subtype.value
                    )
                ) {
                    subtype.checked = true;
                } else {
                    subtype.checked = false;
                }
            });

            this.levelOfInterests.forEach((level) => {
                if (
                    this.filterParameterObj.levelOfInterests.includes(
                        level.value
                    )
                ) {
                    level.checked = true;
                } else {
                    level.checked = false;
                }

                if (level.items) {
                    level.items.forEach((sublevel) => {
                        if (
                            this.filterParameterObj.levelOfInterests.includes(
                                sublevel.value
                            )
                        ) {
                            sublevel.checked = true;
                        } else {
                            sublevel.checked = false;
                        }
                    });
                }
            });

            this.filterParameter.investorSubtypes = angular.copy(
                this.investorSubtypes
            );
            this.filterParameter.levelOfInterests = angular.copy(
                this.levelOfInterests
            );
            this.modal.show();
        };

        // Close filter modal box
        this.closeModal = () => {
            this.modal.hide();
        };

        this.cancelModal = () => {
            this.filterParameter.investorSubtypes = this.investorSubtypes;
            this.filterParameter.levelOfInterests = this.levelOfInterests;

            this.closeModal();
        };

        this.onSort = () => {
            this.filterParameterObj.sortDirection = this.sortOrder.direction;
            this.filterParameterObj.sortOrder = this.sortOrder.field;

            this.onFilter();
        };

        this.showChildren = (id, parent) => {
            switch (parent) {
                case 'packageOne':
                    this.packageTwo = undefined;
                    this.packageThree = undefined;
                    this.packageFour = undefined;
                    if (id) {
                        ApiSelections.getSelectionChildren(id).then(
                            (packagesTwo) => {
                                this.packageTwo = packagesTwo || [];
                            }
                        );
                    }
                    break;
                case 'packageTwo':
                    this.packageThree = undefined;
                    this.packageFour = undefined;
                    if (id) {
                        ApiSelections.getSelectionChildren(id).then(
                            (packagesThree) => {
                                this.packageThree = packagesThree || [];
                            }
                        );
                    }
                    break;
                case 'packageThree':
                    this.packageFour = undefined;
                    if (id) {
                        ApiSelections.getSelectionChildren(id).then(
                            (packagesFour) => {
                                this.packageFour = packagesFour || [];
                            }
                        );
                    }
                    break;
                default:
                    return false;
            }
        };

        // Handle when user clicks filter-go button
        this.onFilter = () => {
            // add selected package to filterParameterObj
            if (this.filterParameter.packageFour) {
                this.filterParameter.package = this.filterParameter.packageFour;
                this.filterParameterObj.selectionId =
                    this.filterParameter.packageFour.selectionId;
            } else if (this.filterParameter.packageThree) {
                this.filterParameter.package =
                    this.filterParameter.packageThree;
                this.filterParameterObj.selectionId =
                    this.filterParameter.packageThree.selectionId;
            } else if (this.filterParameter.packageTwo) {
                this.filterParameter.package = this.filterParameter.packageTwo;
                this.filterParameterObj.selectionId =
                    this.filterParameter.packageTwo.selectionId;
            } else if (this.filterParameter.packageOne) {
                this.filterParameter.package = this.filterParameter.packageOne;
                this.filterParameterObj.selectionId =
                    this.filterParameter.packageOne.selectionId;
            } else {
                this.filterParameter.package = undefined;
                this.filterParameterObj.selectionId = undefined;
            }
            this.filterParameterObj.customerContactType =
                this.filterParameter.customerContactType;
            this.populateFilterCriteria();
            this.contacts = [];

            this.loadCombinedContacts();
            this.filterHistory.saveFilter(
                angular.copy(this.filterParameter),
                'campaign-contact'
            );

            this.getFilterIndicationText();
            this.closeModal();
        };

        // Remove filter
        this.removeContactType = () => {
            if (this.filterParameter.customerContactType) {
                delete this.filterParameter.customerContactType;
            }

            this.onFilter();
        };

        this.removePackage = () => {
            if (this.filterParameter.package) {
                delete this.filterParameter.package;
                delete this.filterParameter.packageOne;
                delete this.filterParameter.packageTwo;
                delete this.filterParameter.packageThree;

                this.filterParameterObj.selectionId = undefined;
            }

            this.onFilter();
        };

        this.removeInvestorType = (subType) => {
            subType.checked = false;
            this.onFilter();
        };

        this.removeLevelOfInterest = (level) => {
            level.checked = false;
            this.onFilter();
        };

        this.removeAllFilters = () => {
            if (this.filterParameter.customerContactType) {
                delete this.filterParameter.customerContactType;
            }

            if (this.filterParameter.package) {
                delete this.filterParameter.package;
                delete this.filterParameter.packageOne;
                delete this.filterParameter.packageTwo;
                delete this.filterParameter.packageThree;

                this.filterParameterObj.selectionId = undefined;
            }

            this.filterParameter.investorSubtypes.map((item) => {
                item.checked = false;
            });

            this.filterParameter.levelOfInterests.map((item) => {
                item.checked = false;
            });
            this.onFilter();
        };

        this.preLoadedFilter = () => {
            let filter = this.filterHistory.readFilter('campaign-contact');

            if (filter) {
                this.filterParameter = filter;
                if (this.filterParameter.package) {
                    this.filterParameterObj.selectionId =
                        this.filterParameter.package.selectionId;
                }

                this.populateFilterCriteria();
                this.getFilterIndicationText();
            }
        };

        this.populateFilterCriteria = () => {
            this.filterParameterObj.investorSubtypes = [];
            this.filterParameter.investorSubtypes.forEach((subtype) => {
                if (subtype.checked) {
                    this.filterParameterObj.investorSubtypes.push(
                        subtype.value
                    );
                }
            });

            this.filterParameterObj.levelOfInterests = [];
            this.filterParameter.levelOfInterests.forEach((level) => {
                if (level.checked) {
                    this.filterParameterObj.levelOfInterests.push(level.value);
                }

                if (level.items) {
                    level.items.forEach((sublevel) => {
                        if (sublevel.checked) {
                            this.filterParameterObj.levelOfInterests.push(
                                sublevel.value
                            );
                        }
                    });
                }
            });

            this.filterParameterObj.firstQueryResult = undefined;
            this.filterParameterObj.searchText =
                this.filterParameter.searchText;
        };

        this.onSearch = (searchText) => {
            this.filterParameter.searchText = searchText;
            this.onFilter();
        };

        this.getLevelOfInterestColor = (levelOfInterest) => {
            const level = this.levelOfInterests.find((item) => {
                return item.value == levelOfInterest;
            });

            return level ? level.color : '#000000';
        };

        this.getFilterIndicationText = () => {
            let filter = this.filterParameterObj;
            let text = '';
            if (!filter) return '';
            if (filter.investorSubtypes && filter.investorSubtypes.length > 0) {
                text = text + $filter('translate')('INVESTOR_TYPES') + ', ';
            }
            if (filter.levelOfInterests && filter.levelOfInterests.length > 0) {
                text = text + $filter('translate')('LEVEL_OF_INTEREST') + ', ';
            }
            if (filter.selectionId && filter.selectionId > 0) {
                text = text + $filter('translate')('PACKAGES') + ', ';
            }
            if (text.length > 0) {
                text = 'Filter by: ' + text.substring(text.length - 2, 0);
            }
            this.filterIndicationText = text;
            this.isFilterActive = text.length > 0;
        };
    },
};

export default contactFilterModal;



/** WEBPACK FOOTER **
 ** ./src/app/directives/campaignContactList/campaignContactList.js
 **/